export interface Chapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  slug: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  status: string;
  rating: number;
  views: number;
  favorites: number;
  chapters: Chapter[];
  updatedAt: string;
  createdAt: string;
  featured: boolean;
  trending: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '霸道总裁的契约新娘',
    slug: 'ba-dao-zong-cai-qi-yue-xin-niang',
    author: '金敏珠',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20cover%20art%20featuring%20a%20handsome%20CEO%20in%20a%20dark%20suit%20and%20a%20elegant%20woman%20in%20a%20white%20dress%20standing%20in%20a%20modern%20city%20skyline%20at%20sunset%20romantic%20atmosphere%20soft%20warm%20lighting%20clean%20illustration%20style%20professional%20manga%20cover%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一场意外的事故让平凡女孩林小夏与帝国集团总裁陆景琛签下了契约婚姻。她以为这只是一场交易，却不知自己早已成为他精心布局的棋子。在谎言与真相交织的世界中，两颗孤独的心能否找到真正的归宿？',
    category: 'romance',
    tags: ['都市', '逆袭', '虐恋'],
    status: '连载中',
    rating: 4.8,
    views: 12860000,
    favorites: 356000,
    chapters: Array.from({ length: 89 }, (_, i) => ({
      id: 1000 + i,
      title: `第${i + 1}话${i < 5 ? [' 命运的相遇', ' 契约缔结', ' 第一次危机', ' 意外的温柔', ' 雨夜'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 30 - i * 3) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2024-03-15',
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: '重生之绝世剑神',
    slug: 'chong-sheng-zhi-jue-shi-jian-shen',
    author: '李正浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20of%20a%20powerful%20swordsman%20with%20flowing%20dark%20hair%20holding%20a%20glowing%20sword%20ancient%20oriental%20fantasy%20palace%20in%20background%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%20epic%20action%20manga%20style%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '一代剑神叶天在飞升失败后重生回到少年时代。带着前世的记忆和剑道感悟，他誓要弥补所有遗憾，碾压所有曾经欺辱过他的人。这一世，他要踏上真正的剑道巅峰，让整个大陆都为之颤抖！',
    category: 'fantasy',
    tags: ['重生', '热血', '古风'],
    status: '连载中',
    rating: 4.9,
    views: 19500000,
    favorites: 512000,
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: 2000 + i,
      title: `第${i + 1}话${i < 5 ? [' 重生归来', ' 初露锋芒', ' 剑意觉醒', ' 宗门大会', ' 一剑破天'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 28 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2023-11-20',
    featured: true,
    trending: true,
  },
  {
    id: 3,
    title: '甜蜜的陷阱',
    slug: 'tian-mi-de-xian-jing',
    author: '朴秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20manhwa%20cover%20two%20young%20people%20sharing%20ice%20cream%20in%20a%20cozy%20cafe%20setting%20cherry%20blossoms%20falling%20outside%20the%20window%20warm%20pink%20and%20peach%20color%20palette%20soft%20romantic%20atmosphere%20beautiful%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '甜点师苏糖糖开了一家小小的甜品店，某天一位神秘顾客每天都来买同一款蛋糕。她不知道的是，这位顾客其实是隐姓埋名的国际甜品大赛评委。一场关于甜品与爱情的双重甜蜜陷阱，正在悄然展开。',
    category: 'romance',
    tags: ['治愈', '都市', '纯爱'],
    status: '连载中',
    rating: 4.7,
    views: 8920000,
    favorites: 234000,
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: 3000 + i,
      title: `第${i + 1}话${i < 5 ? [' 神秘顾客', ' 草莓蛋糕', ' 烘焙比赛', ' 甜蜜告白', ' 意外身份'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 27 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-01-10',
    featured: true,
    trending: false,
  },
  {
    id: 4,
    title: '暗影刺客',
    slug: 'an-ying-ci-ke',
    author: '崔武镇',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20action%20manhwa%20cover%20a%20mysterious%20assassin%20in%20black%20clothing%20with%20a%20hood%20holding%20twin%20daggers%20standing%20on%20a%20rooftop%20at%20night%20city%20lights%20below%20moonlight%20casting%20dramatic%20shadows%20cool%20blue%20and%20black%20color%20scheme&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '曾经的王牌特工尹寒因为一次任务失败被组织抛弃，沦为地下世界的暗影刺客。他以为余生将在黑暗中度过，直到一个神秘小女孩的出现，让他重新找到了活着的意义。为了守护这份温暖，他将与整个地下世界为敌。',
    category: 'action',
    tags: ['热血', '都市', '复仇'],
    status: '已完结',
    rating: 4.8,
    views: 15600000,
    favorites: 389000,
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: 4000 + i,
      title: `第${i + 1}话${i < 5 ? [' 坠落深渊', ' 暗影归来', ' 神秘委托', ' 血染之夜', ' 最后的任务'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 6 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 25 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-06-15',
    createdAt: '2024-06-01',
    featured: false,
    trending: true,
  },
  {
    id: 5,
    title: '我在异世界开餐厅',
    slug: 'wo-zai-yi-shi-jie-kai-can-ting',
    author: '韩志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20Korean%20fantasy%20comedy%20manhwa%20cover%20a%20cheerful%20chef%20in%20a%20magical%20restaurant%20with%20fantasy%20creatures%20as%20customers%20elves%20and%20dragons%20dining%20together%20warm%20golden%20lighting%20whimsical%20atmosphere%20vibrant%20colors%20fun%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '米其林三星主厨林风因为一次厨房爆炸穿越到了剑与魔法的异世界。在这个美食荒漠中，他决定用自己的厨艺征服异世界居民的味蕾！龙肉烧烤、魔法蔬菜沙拉、药水鸡尾酒……当现代料理遇上奇幻食材，一场美食革命就此展开！',
    category: 'comedy',
    tags: ['穿越', '治愈', '系统'],
    status: '连载中',
    rating: 4.6,
    views: 11200000,
    favorites: 298000,
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: 5000 + i,
      title: `第${i + 1}话${i < 5 ? [' 穿越异世界', ' 第一道菜', ' 魔兽肉排', ' 美食大赛', ' 王国邀请'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 26 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2025-03-22',
    featured: false,
    trending: true,
  },
  {
    id: 6,
    title: '迷雾之城的秘密',
    slug: 'mi-wu-zhi-cheng-de-mi-mi',
    author: '尹智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20suspense%20manhwa%20cover%20a%20foggy%20European%20style%20town%20with%20a%20detective%20in%20a%20trench%20coat%20holding%20a%20lantern%20walking%20through%20cobblestone%20streets%20eerie%20atmosphere%20muted%20gray%20and%20teal%20tones%20noir%20style%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '记者姜瑞恩收到一封来自十年未见的好友的求救信，她来到了一个被迷雾笼罩的偏远小镇。镇上居民行为诡异，每个人都似乎隐藏着不可告人的秘密。随着调查深入，她发现整个小镇都与一起二十年前的连环失踪案有关。',
    category: 'suspense',
    tags: ['悬疑', '都市', '复仇'],
    status: '连载中',
    rating: 4.7,
    views: 7650000,
    favorites: 187000,
    chapters: Array.from({ length: 62 }, (_, i) => ({
      id: 6000 + i,
      title: `第${i + 1}话${i < 5 ? [' 求救信', ' 迷雾小镇', ' 第一个秘密', ' 地下室', ' 真相浮现'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 24 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-05-18',
    featured: true,
    trending: false,
  },
  {
    id: 7,
    title: '校园女王的新生',
    slug: 'xiao-yuan-nv-wang-de-xin-sheng',
    author: '宋美妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20school%20romance%20manhwa%20cover%20a%20confident%20girl%20in%20school%20uniform%20walking%20through%20a%20cherry%20blossom%20lined%20campus%20path%20students%20in%20background%20bright%20spring%20colors%20energetic%20youthful%20atmosphere%20beautiful%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '转学生金夏恩来到新学校的第一天就当众教训了校园恶霸，一夜之间成为了全校的焦点。但她不知道的是，被她教训的"恶霸"其实是校长的儿子。一场校园女王与校霸之间的斗智斗勇就此展开，而两人之间的关系也开始微妙地变化。',
    category: 'drama',
    tags: ['校园', '逆袭', '纯爱'],
    status: '连载中',
    rating: 4.5,
    views: 10200000,
    favorites: 267000,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: 7000 + i,
      title: `第${i + 1}话${i < 5 ? [' 转校第一天', ' 校园风云', ' 学生会竞选', ' 运动会', ' 天台约定'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 25 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2025-02-14',
    featured: false,
    trending: true,
  },
  {
    id: 8,
    title: '神级驯兽师',
    slug: 'shen-ji-xun-shou-shi',
    author: '张贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20action%20manhwa%20cover%20a%20young%20tamer%20with%20a%20massive%20mythical%20dragon%20behind%20him%20ancient%20ruins%20in%20background%20magical%20energy%20flowing%20around%20epic%20scale%20vibrant%20jade%20and%20gold%20color%20palette%20stunning%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在一个以驯服魔兽为尊的世界里，少年江辰觉醒了传说中的神级驯兽天赋。别人用一生才能驯服一只魔兽，他却能让所有魔兽主动臣服。当百年一遇的魔兽潮来临之时，他将是人类最后的希望。',
    category: 'fantasy',
    tags: ['热血', '系统', '养成'],
    status: '连载中',
    rating: 4.7,
    views: 13800000,
    favorites: 345000,
    chapters: Array.from({ length: 105 }, (_, i) => ({
      id: 8000 + i,
      title: `第${i + 1}话${i < 5 ? [' 觉醒之日', ' 第一只魔兽', ' 学院考核', ' 魔兽森林', ' 龙之契约'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 26 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2024-09-01',
    featured: false,
    trending: true,
  },
  {
    id: 9,
    title: '深夜便利店的她',
    slug: 'shen-ye-bian-li-dian-de-ta',
    author: '赵恩静',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20Korean%20slice%20of%20life%20manhwa%20cover%20a%20girl%20working%20in%20a$%20convenience%20store%20at%20night%20warm%20fluorescent%20lights%20inside%20quiet%20empty%20street%20outside%20cozy%20nostalgic%20atmosphere%20soft%20yellow%20and%20blue%20tones%20gentle%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '大学生李志浩习惯在深夜去学校旁边的便利店买泡面。他发现每次深夜值班的都是同一个女孩，她总是安静地看书，偶尔抬头对客人微笑。一个失眠的夜晚，他终于鼓起勇气和她说了第一句话。这就是一段关于深夜、便利店和两个孤独灵魂的故事。',
    category: 'drama',
    tags: ['治愈', '校园', '都市'],
    status: '已完结',
    rating: 4.9,
    views: 9800000,
    favorites: 421000,
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: 9000 + i,
      title: `第${i + 1}话${i < 5 ? [' 深夜的泡面', ' 她的名字', ' 雨天的伞', ' 第一个约会', ' 告白的夜晚'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 5 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 20 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-05-20',
    createdAt: '2025-07-07',
    featured: false,
    trending: false,
  },
  {
    id: 10,
    title: '废柴皇子逆天记',
    slug: 'fei-chai-huang-zi-ni-tian-ji',
    author: '吴泰浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20historical%20fantasy%20manhwa%20cover%20a%20young%20prince%20in%20traditional%20Korean%20royal%20robe%20standing%20proudly%20in%20front%20of%20a%20grand%20palace%20golden%20sunset%20sky%20dramatic%20clouds%20rich%20red%20and%20gold%20colors%20majestic%20atmosphere%20detailed%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '七皇子李玄因为天生经脉残破被所有人视为废柴，就连宫中的太监都敢欺辱他。然而一次偶然的机会，他得到了一本上古秘籍，从此逆天改命！当他以碾压之势回归朝堂之时，所有人都要为他曾经的屈辱付出代价。',
    category: 'fantasy',
    tags: ['穿越', '逆袭', '古风'],
    status: '连载中',
    rating: 4.8,
    views: 16800000,
    favorites: 478000,
    chapters: Array.from({ length: 135 }, (_, i) => ({
      id: 10000 + i,
      title: `第${i + 1}话${i < 5 ? [' 废柴皇子', ' 上古秘籍', ' 初显身手', ' 朝堂风云', ' 龙椅之争'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 28 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-05',
    createdAt: '2023-08-12',
    featured: true,
    trending: true,
  },
  {
    id: 11,
    title: '杀手爸爸的育儿日记',
    slug: 'sha-shou-ba-ba-de-yu-er-ri-ji',
    author: '郑泰民',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20comedy%20manhwa%20cover%20a%20tough%20looking%20man%20in%20black%20suit%20awkwardly%20holding%20a%20baby%20bottle%20with%20a%20cute%20baby%20girl%20in%20his%20arms%20contrast%20between%20his%20appearance%20and%20situation%20bright%20playful%20colors%20funny%20touching%20illustration&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '地下世界的传奇杀手"夜叉"在执行最后一次任务时，意外捡到了一个被遗弃的女婴。从此，他的生活发生了天翻地覆的变化。换尿布比拆炸弹还难，哄睡觉比潜入敌营更考验耐心。一个冷酷杀手的手忙脚乱育儿日常，笑中带泪！',
    category: 'comedy',
    tags: ['治愈', '都市', '养成'],
    status: '连载中',
    rating: 4.8,
    views: 14500000,
    favorites: 523000,
    chapters: Array.from({ length: 84 }, (_, i) => ({
      id: 11000 + i,
      title: `第${i + 1}话${i < 5 ? [' 意外的礼物', ' 第一天当爸', ' 幼儿园危机', ' 前组织来袭', ' 最好的爸爸'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 25 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2024-12-01',
    featured: true,
    trending: true,
  },
  {
    id: 12,
    title: '死亡游戏的幸存者',
    slug: 'si-wang-you-xi-de-xing-cun-zhe',
    author: '姜道允',
    cover: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Korean%20suspense%20manhwa%20cover%20a%20group%20of%20people%20trapped%20in%20a%20dark%20game%20arena%20with%20red%20warning%20lights%20a%20determined%20main%20character%20in%20the%20center%20tense%20dangerous%20atmosphere%20dark%20red%20and%20black%20color%20scheme%20cinematic%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '一觉醒来，高中生韩宇发现自己和二十九个陌生人被困在一个封闭的建筑物中。一个神秘的声音宣布：参加死亡游戏，最后的幸存者可以获得任何愿望。信任与背叛、牺牲与自私，在这场残酷的游戏中，人性的每一个面都将被放大到极致。',
    category: 'suspense',
    tags: ['悬疑', '热血', '系统'],
    status: '连载中',
    rating: 4.7,
    views: 12300000,
    favorites: 312000,
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: 12000 + i,
      title: `第${i + 1}话${i < 5 ? [' 游戏开始', ' 第一个牺牲者', ' 结盟与背叛', ' 隐藏规则', ' 最终关卡'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 24 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2025-04-10',
    featured: false,
    trending: false,
  },
  {
    id: 13,
    title: '王妃的华丽复仇',
    slug: 'wang-fei-de-hua-li-fu-chou',
    author: '柳慧珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20historical%20romance%20manhwa%20cover%20a%20beautiful%20woman%20in%20elegant%20traditional%20Korean%20hanbok%20with%20a%20cold%20determined%20expression%20standing%20in%20a%20royal%20palace%20garden%20rose%20petals%20falling%20dramatic%20lighting%20rich%20burgundy%20and%20cream%20color%20palette&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '前世被丈夫和庶妹联手陷害致死的王妃沈若兰，重生回到了出嫁前的那一天。这一世，她不再做任人宰割的柔弱女子。她要让所有伤害过她的人付出百倍的代价，而那个曾经对她不屑一顾的王爷，这一世却对她痴迷不已……',
    category: 'romance',
    tags: ['重生', '古风', '逆袭'],
    status: '连载中',
    rating: 4.8,
    views: 17200000,
    favorites: 489000,
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: 13000 + i,
      title: `第${i + 1}话${i < 5 ? [' 重生归来', ' 改变命运', ' 宫宴惊鸿', ' 计中计', ' 王爷的心'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 27 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-05',
    createdAt: '2024-04-20',
    featured: true,
    trending: true,
  },
  {
    id: 14,
    title: '爆笑武林录',
    slug: 'bao-xiao-wu-lin-lu',
    author: '白东秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20hilarious%20Korean%20martial%20arts%20comedy%20manhwa%20cover%20a%20young%20clumsy%20martial%20artist%20with%20exaggerated%20expressions%20tripping%20over%20his%20own%20sword%20colorful%20ancient%20Chinese%20village%20background%20bright%20saturated%20colors%20cartoonish%20fun%20style&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '武林中最不靠谱的弟子白小飞，武功平平却梦想成为天下第一。他意外得到了一本"绝世武功秘籍"，结果发现是本恶搞版。然而就是这本假秘籍，竟然让他阴差阳错地打败了各路高手。一出武林爆笑喜剧，笑到停不下来！',
    category: 'comedy',
    tags: ['古风', '热血', '搞笑'],
    status: '连载中',
    rating: 4.5,
    views: 8900000,
    favorites: 201000,
    chapters: Array.from({ length: 65 }, (_, i) => ({
      id: 14000 + i,
      title: `第${i + 1}话${i < 5 ? [' 最弱弟子', ' 假秘籍', ' 误打误撞', ' 武林大会', ' 出人意料'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 23 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2025-06-15',
    featured: false,
    trending: false,
  },
  {
    id: 15,
    title: '深渊图书馆',
    slug: 'shen-yuan-tu-shu-guan',
    author: '崔珉豪',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20fantasy%20manhwa%20cover%20an%20ancient%20library%20with%20endless%20bookshelves%20reaching%20into%20darkness%20a%20lone%20figure%20holding%20a%20glowing%20book%20magical%20dust%20particles%20floating%20in%20the%20air%20deep%20indigo%20and%20amber%20tones%20atmospheric%20illustration&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '大学生金秀贤在学校的旧图书馆发现了一本没有书名的古书。当他翻开书页的那一刻，他被吸入了书中的世界。每一本书都是一个不同的世界，每一个故事都隐藏着关于这座"深渊图书馆"的秘密。而他，似乎是被选中的第1001位图书馆管理员。',
    category: 'fantasy',
    tags: ['悬疑', '穿越', '系统'],
    status: '连载中',
    rating: 4.6,
    views: 7800000,
    favorites: 198000,
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: 15000 + i,
      title: `第${i + 1}话${i < 5 ? [' 无字之书', ' 第一个世界', ' 书页之间', ' 管理员', ' 深渊之谜'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 22 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-08-01',
    featured: false,
    trending: false,
  },
  {
    id: 16,
    title: '格斗天王',
    slug: 'ge-dou-tian-wang',
    author: '朴成宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20fighting%20manhwa%20cover%20a%20muscular%20fighter%20in%20boxing%20shorts%20throwing%20a%20powerful%20punch%20in%20a%20crowded%20arena%20spotlight%20on%20him%20sweat%20flying%20intense%20expression%20vibrant%20orange%20and%20black%20colors%20explosive%20energy&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    description: '曾经的地下格斗冠军姜泰浩因为一场意外失去了所有，沦为街头混混。五年后，当他的妹妹被黑帮绑架，他决定重返格斗场。这一次，他不仅要夺回失去的荣誉，更要守护自己唯一的亲人。拳拳到肉的热血格斗，燃爆全场！',
    category: 'action',
    tags: ['热血', '都市', '复仇'],
    status: '连载中',
    rating: 4.7,
    views: 13500000,
    favorites: 356000,
    chapters: Array.from({ length: 92 }, (_, i) => ({
      id: 16000 + i,
      title: `第${i + 1}话${i < 5 ? [' 坠落冠军', ' 街头求生', ' 地下拳场', ' 王者归来', ' 终极对决'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 26 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2024-07-15',
    featured: false,
    trending: true,
  },
  {
    id: 17,
    title: '月光下的约定',
    slug: 'yue-guang-xia-de-yue-ding',
    author: '安秀晶',
    cover: 'https://readdy.ai/api/search-image?query=A%20dreamy%20Korean%20romance%20manhwa%20cover%20a%20young%20couple%20holding%20hands%20under%20a%20large%20full%20moon%20on%20a%20quiet%20beach%20gentle%20waves%20in%20background%20starlit%20sky%20soft%20silver%20and%20lavender%20color%20palette%20ethereal%20romantic%20illustration&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    description: '幼年时，韩素希和邻家哥哥在月光下许下了"长大后要结婚"的约定。十年后，当她再次遇到那个男孩时，他已经是当红偶像组合的成员。两人的世界天差地别，但童年的约定却如月光般温柔地连接着彼此。一段跨越身份与距离的纯爱故事。',
    category: 'romance',
    tags: ['纯爱', '治愈', '校园'],
    status: '已完结',
    rating: 4.6,
    views: 9600000,
    favorites: 278000,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: 17000 + i,
      title: `第${i + 1}话${i < 5 ? [' 月光下的回忆', ' 重逢', ' 偶像与普通人', ' 秘密约会', ' 永远在一起'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 4 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 18 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-04-12',
    createdAt: '2025-09-20',
    featured: false,
    trending: false,
  },
  {
    id: 18,
    title: '魔女的救赎',
    slug: 'mo-nv-de-jiu-shu',
    author: '郑艺琳',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20a%20mysterious%20witch%20with%20long%20silver%20hair%20in%20a%20flowing%20black%20dress%20surrounded%20by%20magical%20runes%20and%20crystals%20dark%20forest%20background%20moonlight%20breaking%20through%20trees%20mystical%20purple%20and%20emerald%20color%20palette&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    description: '传说中在诅咒森林深处住着一位可怕的魔女，她会夺走闯入者的灵魂。但没有人知道，所谓"魔女"只是一个被诅咒困在森林中千年的可怜女孩。当一个迷路的少年误入森林，少女看到了打破诅咒的最后希望。一段关于救赎与希望的黑暗童话。',
    category: 'fantasy',
    tags: ['治愈', '悬疑', '纯爱'],
    status: '连载中',
    rating: 4.7,
    views: 10800000,
    favorites: 289000,
    chapters: Array.from({ length: 70 }, (_, i) => ({
      id: 18000 + i,
      title: `第${i + 1}话${i < 5 ? [' 诅咒森林', ' 迷路少年', ' 魔女真相', ' 破解诅咒', ' 千年之约'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 23 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2025-02-28',
    featured: false,
    trending: false,
  },
  {
    id: 19,
    title: '医道至尊',
    slug: 'yi-dao-zhi-zun',
    author: '孙志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20medical%20fantasy%20manhwa%20cover%20a%20young%20doctor%20in%20traditional%20Korean%20medicine%20robe%20holding%20acupuncture%20needles%20with%20glowing%20energy%20flowing%20ancient%20medical%20hall%20background%20warm%20amber%20lighting%20healing%20atmosphere%20detailed%20illustration&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    description: '现代医学天才林逸在一次医疗事故中穿越到了古代，成为了一个乡下小郎中。凭借超越时代千年的医学知识和一双能看透人体经络的"天眼"，他在这个医疗落后的时代掀起了一场医学革命。悬壶济世，医道至尊！',
    category: 'drama',
    tags: ['穿越', '热血', '古风'],
    status: '连载中',
    rating: 4.6,
    views: 9800000,
    favorites: 245000,
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: 19000 + i,
      title: `第${i + 1}话${i < 5 ? [' 穿越古代', ' 天眼觉醒', ' 京都瘟疫', ' 太医院', ' 医圣之名'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 25 - i * 2) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-01-05',
    featured: false,
    trending: false,
  },
  {
    id: 20,
    title: '双重人格侦探',
    slug: 'shuang-chong-ren-ge-zhen-tan',
    author: '李道贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20psychological%20thriller%20manhwa%20cover%20a%20detective%20with%20a%20split%20personality%20shown%20as%20two%20faces%20merged%20together%20one%20calm%20one%20manic%20crime%20scene%20tape%20in%20background%20rainy%20night%20atmosphere%20contrasting%20cool%20blue%20and%20warm%20red%20tones&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    description: '警探韩瑞俊在一次追捕中脑部受创，醒来后发现自己拥有了一重截然不同的人格。白天是冷静理性的精英警探，夜晚则变成了直觉敏锐的疯狂推理者。双重人格携手破案，让罪犯无处遁形。但一个更大的秘密正在等待着他：哪一个人格才是真正的自己？',
    category: 'suspense',
    tags: ['悬疑', '都市', '系统'],
    status: '连载中',
    rating: 4.8,
    views: 11800000,
    favorites: 334000,
    chapters: Array.from({ length: 76 }, (_, i) => ({
      id: 20000 + i,
      title: `第${i + 1}话${i < 5 ? [' 意外事故', ' 黑夜中的他', ' 连环杀手', ' 双重推理', ' 真实身份'][i] : ''}`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 24 - i) % 28 + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2024-11-08',
    featured: false,
    trending: true,
  },
];

export function getComicsByCategory(categorySlug: string): Comic[] {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.category === categorySlug);
}

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getFeaturedComics(): Comic[] {
  return comics.filter((c) => c.featured);
}

export function getTrendingComics(): Comic[] {
  return comics.filter((c) => c.trending).sort((a, b) => b.views - a.views);
}

export function getLatestUpdates(limit: number = 12): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getPopularComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getRelatedComics(comic: Comic, limit: number = 6): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && (c.category === comic.category || c.tags.some((t) => comic.tags.includes(t))))
    .slice(0, limit);
}